import { TextField } from '@mui/material'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { getPropertyName } from '../../helpers/utils'
import BaseElement from './BaseElement'

const TextMutator = ({ definition, value, itemKey, buttons, handleUpdate }) => {
  const [controlledValue, setValue] = useState(value)
  const title = useMemo(() => getPropertyName(definition?.title, itemKey), [definition, itemKey])

  const handleChange = useCallback((event) => {
    const newValue = event.target.value
    if (value !== newValue) {
      setValue(newValue)
      handleUpdate(newValue)
    }
  }, [handleUpdate, value])

  useEffect(() => {
    setValue(value)
  }, [value])

  return (
    <BaseElement error={!definition}>
      <header-area>
        <span>{title}</span>
        <div>
          {buttons}
        </div>
      </header-area>
      <TextField
        value={controlledValue}
        size='small'
        multiline
        fullWidth
        minRows={1}
        maxRows={10}
        style={{ flexGrow: 1 }}
        error={!definition}
        onChange={handleChange}
      />
    </BaseElement>
  )
}

export default TextMutator